import { isDefined, isTruthy } from 'notable-common';
import { z } from 'zod';
import { FlowRunExecutionMode } from '../../../flowRun/executionMode.js';
import { FlowBlockValueUsPhoneNumberSchema } from '../../blockValue/phoneNumberSchema.js';
import { FlowBlockValueTemplateHint, validateFlowBlockValueTemplate, } from '../../blockValue/template.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
/**
 * Validates every `{{...}}` template embedded in a free-text value, rather than requiring the whole
 * value to be one template.
 */
export function validateFlowBlockValueTemplatesInString(value) {
    const matches = value.match(/{{[^{}]+}}/g);
    if (!isDefined(matches)) {
        return [];
    }
    return matches.map((match) => {
        const validation = validateFlowBlockValueTemplate(match);
        return {
            template: match,
            hint: validation.hint,
            message: validation.hint === FlowBlockValueTemplateHint.Invalid ? validation.message : undefined,
        };
    });
}
function FlowDocumoCoversheetFieldSchema(maxLength) {
    return z
        .string()
        .optional()
        .superRefine((value, context) => {
        if (!isTruthy(value)) {
            return;
        }
        const templates = validateFlowBlockValueTemplatesInString(value);
        if (isTruthy(templates.length)) {
            templates
                .filter((template) => template.hint === FlowBlockValueTemplateHint.Invalid)
                .forEach((template) => {
                context.addIssue({
                    code: 'custom',
                    message: `Invalid template "${template.template}": ${template.message ?? ''}`,
                });
            });
            return;
        }
        if (value.length > maxLength) {
            context.addIssue({
                code: 'custom',
                message: `Input is longer than ${String(maxLength)} characters.`,
            });
        }
    });
}
/* eslint-disable @typescript-eslint/no-deprecated -- the block schema must reference the deprecated run-execution mode while it remains supported */
export const FlowFaxBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Fax),
    config: z.object({
        fileReference: z.string(),
        faxNumber: FlowBlockValueUsPhoneNumberSchema({ isRequired: true }),
        attachDocumoCoversheet: z.boolean().default(false),
        documoCoversheet: z
            .object({
            id: z.string(),
            recipientName: FlowDocumoCoversheetFieldSchema(40),
            senderName: FlowDocumoCoversheetFieldSchema(40),
            subject: FlowDocumoCoversheetFieldSchema(55),
            notes: FlowDocumoCoversheetFieldSchema(400),
        })
            .optional(),
        runMode: z.enum(FlowRunExecutionMode).default(FlowRunExecutionMode.Live),
    }),
});
//# sourceMappingURL=config.js.map